import React, { useState, useEffect } from 'react'
import { Button, Typography } from '@mui/material';
import { Modal, Accordion } from 'react-bootstrap'
import UpdateForm from './UpdateForm'

export default function ExtrasSetup() {

  const [createNewFlag, setCreateNewFlag] = useState(false)
  const [lgShow, setLgShow] = useState(false);
  const [accessType, setAccessType] = useState('');

  //API call
  useEffect(() => {

    const loggedInUser = sessionStorage.getItem("user_token");
    const foundUser = JSON.parse(loggedInUser);

    if (foundUser.role_capabilities?.all_modules_access === true) {

      setAccessType('Edit');

    }
    else {

      setAccessType(foundUser.access['OptionalServices_Access Specifier']);
    }

  }, []);


  return (
    <>

      <div className="row">

        <div className="row my-3 ">
          <div className="col-md-6">
            <Typography className="mx-3" variant='h4' sx={{ pb: 3 }}>
              Optional Services {accessType === 'View' ? " / View Only Mode" : ""}
            </Typography>
          </div>
          <div className="col-md-6 d-flex justify-content-end"   >

            <button type="button" className="btn btn-danger" onClick={() => setLgShow(true)} style={{ height: "40px" }}  >Help</button>
            <Modal
              size="lg"
              show={lgShow}
              onHide={() => setLgShow(false)}
              aria-labelledby="example-modal-sizes-title-lg"

            >
              <Modal.Header closeButton style={{ color: '#FFFFFF', backgroundColor: '#C62828' }}>
                <Modal.Title id="example-modal-sizes-title-lg" >
                  Instructions to Add/Edit Optional Services
                </Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ backgroundColor: '#F8FAFC', padding: '24px' }}>
                <style>{`
                  .help-badge {
                    padding: 4px 10px;
                    border-radius: 16px;
                    font-weight: 700;
                    font-size: 12px;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    margin-right: 10px;
                  }
                  .badge-create { background: #e6fffa; color: #234e52; border: 1px solid #b2f5ea; }
                  .badge-update { background: #fffaf0; color: #9c4221; border: 1px solid #feebc8; }
                  .badge-delete { background: #fff5f5; color: #9b2c2c; border: 1px solid #fed7d7; }
                  
                  .help-card-text {
                    font-size: 14px;
                    color: #4a5568;
                    line-height: 1.5;
                    margin-bottom: 16px;
                  }
                  .video-responsive-wrapper {
                    position: relative;
                    width: 100%;
                    padding-top: 56.25%; /* 16:9 Aspect Ratio */
                    border-radius: 8px;
                    overflow: hidden;
                    background: #000000;
                  }
                  .video-responsive-wrapper video {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                  }
                  .accordion-button:not(.collapsed) {
                    background-color: #f1f5f9;
                    color: #1e293b;
                  }
                `}</style>

                <Accordion defaultActiveKey="0" flush>

                  {/* 1. CREATE OPTIONAL SERVICE */}
                  <Accordion.Item eventKey="0" className="mb-2 border rounded">
                    <Accordion.Header>
                      <span className="help-badge badge-create">Create</span>
                      <strong>How to Create Optional Services</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="help-card-text">
                        To create an Optional Service, select the <strong>Account Name</strong> and <strong>Location Name</strong> from the dropdown (the Account ID and Location ID will populate automatically). Click <strong>Add New</strong>, enter the Service Name, Extras Type, Base Rate, Per Day/Per Rental selection, Taxable status, and Car Class, then click <strong>Save</strong>. If applicable, configure the related Fees, State Tax, or Compound Tax details.
                      </p>
                      <div className="video-responsive-wrapper">
                        <video controls preload="metadata" playsInline>
                          <source src="https://d1efa1i7wh44gq.cloudfront.net/optional no tax - create.mp4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                      <hr></hr>
                      <div className="video-responsive-wrapper">
                        <video controls preload="metadata" playsInline>
                          <source src="https://d1efa1i7wh44gq.cloudfront.net/optional with tax - create.mp4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* 2. UPDATE OPTIONAL SERVICE */}
                  <Accordion.Item eventKey="1" className="mb-2 border rounded">
                    <Accordion.Header>
                      <span className="help-badge badge-update">Update</span>
                      <strong>How to Edit Optional Services</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="help-card-text">
                        To update an existing Optional Service, select the <strong>Account Name</strong> and <strong>Location Name</strong>, choose the required service, edit the details as needed, and save the changes. The associated details can also be viewed or updated based on the applicable tax type.
                      </p>
                      <div className="video-responsive-wrapper">
                        <video controls preload="metadata" playsInline>
                          <source src="https://d1efa1i7wh44gq.cloudfront.net/optional - edit.mp4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* 3. DELETE OPTIONAL SERVICE */}
                  <Accordion.Item eventKey="2" className="mb-2 border rounded">
                    <Accordion.Header>
                      <span className="help-badge badge-delete">Delete</span>
                      <strong>How to Delete Optional Services</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="help-card-text">
                        Select the vendor and location, hover over the item that needs to be deleted, and click on the <strong>Delete icon</strong>. Confirm the prompt to complete deletion.
                      </p>
                      <div className="video-responsive-wrapper">
                        <video controls preload="metadata" playsInline>
                          <source src="https://d1efa1i7wh44gq.cloudfront.net/optional - delete.mp4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                </Accordion>
              </Modal.Body>
            </Modal>

          </div>
        </div>


        {/* <div className="col-4 d-flex justify-content-end px-5">
        
          
         
        </div> */}

      </div>

      {accessType === 'View' ? <UpdateForm accessType={accessType} /> : <UpdateForm />}

    </>
  );
}
